import React from 'react';

const TableOptionsIcon = () => {
    return (
        <svg
            data-v-7026e802=""
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 25"
            aria-labelledby="box"
            role="presentation"
        >
            <title data-v-7026e802="" id="box" lang="en">
                box
            </title>{' '}
            <g data-v-7026e802="" fill="currentColor">
                <g
                    data-v-7026e802=""
                    id="Page-1"
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                >
                    <g
                        data-v-7026e802=""
                        id="Tablet-Copy"
                        transform="translate(-200.000000, -1733.000000)"
                        stroke="currentColor"
                        stroke-width="1.5"
                    >
                        <g data-v-7026e802="" id="test" transform="translate(200.000000, 1733.000000)">
                            <path
                                data-v-7026e802=""
                                d="M17.49,18 C18.1015598,18.0244818 18.666656,17.6749479 18.9178492,17.11682 C19.1690423,16.5586921 19.0559443,15.9039276 18.6320805,15.4624027 C18.2082167,15.0208779 17.5586116,14.8811602 16.9907,15.1093729 C16.4227883,15.3375856 16.0504898,15.8879506 16.05,16.5 C16.0338175,17.3117078 16.6783078,17.9830519 17.49,18 Z"
                                id="Path"
                            ></path>{' '}
                            <path
                                data-v-7026e802=""
                                d="M18.713,10.7 L19.137,12.152 C19.2684604,12.6450951 19.7663365,12.9459413 20.264,12.833 L21.677,12.492 C22.2343521,12.365089 22.8077112,12.6267864 23.077,13.131 C23.3580242,13.6418076 23.287995,14.2740711 22.902,14.711 L21.913,15.82 C21.5699969,16.2092141 21.5699969,16.7927859 21.913,17.182 L22.9,18.3 C23.2845997,18.737309 23.3537866,19.3687893 23.073,19.879 C22.8042101,20.3837442 22.2304262,20.6456356 21.673,20.518 L20.26,20.177 C19.7625146,20.0651573 19.2653502,20.3655735 19.133,20.858 L18.713,22.3 C18.5691657,22.8578382 18.0660831,23.2476589 17.49,23.2476589 C16.9139169,23.2476589 16.4108343,22.8578382 16.267,22.3 L15.843,20.848 C15.7106446,20.355099 15.2128197,20.0545505 14.715,20.167 L13.3,20.51 C12.7426108,20.6372729 12.1690397,20.3754786 11.9,19.871 C11.6195174,19.3607287 11.688684,18.729434 12.073,18.292 L13.063,17.181 C13.4060031,16.7917859 13.4060031,16.2082141 13.063,15.819 L12.073,14.708 C11.6879009,14.2705967 11.6183149,13.6387239 11.899,13.128 C12.1682888,12.6237864 12.7416479,12.362089 13.299,12.489 L14.712,12.83 C15.2099085,12.9429991 15.7080895,12.6422356 15.84,12.149 L16.264,10.697 C16.4089707,10.1394522 16.9128515,9.75065555 17.4889372,9.75183316 C18.0650229,9.75301076 18.5673099,10.1438641 18.71,10.702 L18.713,10.7 Z M0.753,11.749 L9.753,11.749 L0.753,11.749 Z"
                                id="Shape"
                            ></path>{' '}
                            <path
                                data-v-7026e802=""
                                d="M8.253,17.249 L2.753,17.249 C1.6484305,17.249 0.753,16.3535695 0.753,15.249 L0.753,2.749 C0.753,1.6444305 1.6484305,0.749 2.753,0.749 L17.753,0.749 C18.8575695,0.749 19.753,1.6444305 19.753,2.749 L19.753,7.611 M0.753,6.249 L19.753,6.249 M7.906,6.249 L7.906,12.999 M13.879,6.25 L13.879,8.219"
                                id="Shape"
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default TableOptionsIcon;
